<template>
    <div class="business">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
  
      <div>
        
        <!-- Table -->
         <div class="datatable-outer-container">
              <div class="datatable-main">
                  <table class="datatable">
                    <thead>
                      <tr class="header-row">
                        <th>Particulars</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer salary income
                      </td>
                      <td class="row-item">
                        <txt
                      type="number"
                      name="salary_income"
                      v-model="previousEmploymentDetailsData.salary_income.planned"
                      @change="(val) => changeInSalaryIncome(val)"
                    />
                      </td>
                    </tr>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer PT amount
                      </td>
                      <td class="row-item">
                        <txt type="number" name="pt" v-model="previousEmploymentDetailsData.pt.planned" :disable="previousEmploymentDetailsData.salary_income.planned <= 0"/>
                      </td>
                    </tr>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer VPF
                      </td>
                      <td class="row-item">
                        <txt type="number" name="vpf" v-model="previousEmploymentDetailsData.vpf.planned" :disable="previousEmploymentDetailsData.salary_income.planned <= 0"/>
                      </td>
                    </tr>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer PF
                      </td>
                      <td class="row-item">
                        <txt type="number" name="pf" v-model="previousEmploymentDetailsData.pf.planned" :disable="previousEmploymentDetailsData.salary_income.planned <= 0"/>
                      </td>
                    </tr>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer NPS
                      </td>
                      <td class="row-item">
                        <txt type="number" name="nps" v-model="previousEmploymentDetailsData.nps.planned" :disable="previousEmploymentDetailsData.salary_income.planned <= 0"/>
                      </td>
                    </tr>
                    <tr class="record-row">
                      <td class="row-item">
                        Previous employer Income tax deduction
                      </td>
                      <td class="row-item">
                        <txt type="number" name="tds" v-model="previousEmploymentDetailsData.tds.planned" :disable="previousEmploymentDetailsData.salary_income.planned <= 0"/>
                      </td>
                    </tr>
                  </table>
                </div>
          </div>
        <!-- End -->
  
        <!-- <pop-up-message
          v-if="showSuccessMsg"
          :message="`Components successfully added`"
          btnText="Back To Assign Fixed Non CTC Components "
          @back="close"
        ></pop-up-message> -->
  
        <footer>
          <popup-bottom-container>
            <template slot="end">
              <btn-grp class="form-button">
                <btn text="Cancel" type="secondary" @click="goBack"/>
                <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" @click="submitData" v-if="itEnableValue"/>
              </btn-grp>
            </template>
          </popup-bottom-container>
        </footer>
      </div>
    </div>
  </template>
  
  <script>
  
  import { mapState, mapActions, mapGetters } from "vuex";
  
  export default {
    name: "incomeFromPreviousEmployer",
    props: {
      previousEmploymentDetails:{
        type:Object
      },
      saveAsDraft: {
        type: Boolean
      },
    itEnableValue:{
      type: String,
      required: true
    }
    },
    data() {
      return {
        errmsg: "",
        toast: false,
        showSuccessMsg: false,
        
        salaryAmount:"",
        previousEmploymentDetailsData: {
          salary_income: { planned: 0, actual: 0, approved: 0, /*location: []*/ },
          pt: { planned: 0, actual: 0, approved: 0, /*location: []*/ },
          vpf: { planned: 0, actual: 0, approved: 0, /*location: []*/ },
          pf: { planned: 0, actual: 0, approved: 0, /*location: []*/ },
          nps: { planned: 0, actual: 0, approved: 0, /*location: []*/ },
          tds: { planned: 0, actual: 0, approved: 0, /*location: []*/ }
        }
      };
    },
    computed: {},
  
    mounted() {
      this.showSuccessMsg = false;
      this.load();
    },
  
    activated() {
      this.toast = false;
      this.errmsg = "";
      this.showSuccessMsg = false;
    },
  
    methods: {
      ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),
      load(){
        if (Object.keys(this.previousEmploymentDetails).length) {
              this.previousEmploymentDetailsData = this.previousEmploymentDetails;
            }
        
        //console.log("inside previous data",this.previousEmploymentDetailsData);
      },
      async submitData(){
        this.$emit("previousDataUpdate",this.previousEmploymentDetailsData);
       //  this.previousEmpData.salary_income.amount=this.salaryAmount;
      },

      changeInSalaryIncome(val){
        if (val == 0){
          this.previousEmploymentDetailsData.pt.planned = 0;
          this.previousEmploymentDetailsData.pf.planned = 0;
          this.previousEmploymentDetailsData.nps.planned = 0;
          this.previousEmploymentDetailsData.tds.planned = 0;
          this.previousEmploymentDetailsData.vpf.planned = 0;
        }
      },
  
      // Add here code for cancel button to hide popup By Bhushan 
      goBack() {
        this.$emit('back');
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  // .business {
  //   width: 100%;
  //   height: 100%;
  // }
  
  // .business .top-bar {
  //   height: auto;
  //   padding: 20px;
  //   background-color: #34c0be;
  //   display: flex;
  // }
  
  
  .section-table {
    padding: 24px 0px;
  }
  
  .datatable-outer-container {
    width: 100%;
  }
          
  .datatable-outer-container table.datatable {
              width: 100%;
              border-collapse: collapse;
              margin: 0 auto;
              font-family: Montserrat;
              margin-bottom: 4px;
  }
          
          .datatable-outer-container table.datatable .header-row {
              background-color: white;
              height: 54px;
          }
          
          .datatable-outer-container table.datatable .header-row th {
              background-color: #f0f1f5;
              border-bottom: 1px solid #34c0be;
              padding: 6px 20px;
          }
          
          .datatable-outer-container table.datatable .header-row th .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .inactiveCols {
              opacity: 0.03;
              background-color: #a2a1a1;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader {
              background-color: #ffffff;
              -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
              box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th {
              padding: 0 8px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span {
              border-right: 1px solid #ececec;
              padding: 0px 18px 0px 15px;
              display: inline-block;
              vertical-align: middle;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
              padding: 10px 10px 7px 10px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
              text-align: right;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
              border-right: none;
              font-weight: 400;
              font-style: italic;
              position: relative;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
              position: absolute;
              right: 10px;
              top: 2px;
          }
          
          .datatable-outer-container table.datatable .record-row {
              height: 54px;
              border-bottom: none;
          }
          
          .datatable-outer-container table.datatable .record-row:nth-child(odd) {
              background-color: #fff;
          }
          
          .datatable-outer-container table.datatable .record-row.selectedRecord {
              background-color: #E9F9F8;
              opacity: 0.9;
          }
          
          .datatable-outer-container table.datatable .record-row td {
              padding: 6px 8px;
              color: #646464;
              font-weight: 500;
          }
          
          .datatable-outer-container table.datatable .record-row td .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .record-row .actions {
              width: 10%;
              padding: 10px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item {
              padding: 6px 20px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item p {
              width: 100%;
              margin-bottom: 0px;
          }
          
          .datatable-outer-container table.datatable .record-row .action-img {
              display: inline-block;
              cursor: pointer;
              opacity: 0;
          }
          
          .datatable-outer-container table.datatable .record-row:hover .action-img {
              opacity: 1;
          }
  
  .inputbox{
     width: 149px;
    height: 35px;
    // width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;
    &:focus {
          outline: none;
          border: 2px solid #37c6c0;
      }
  }
  </style>
  